import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  HttpResponse,
  PortfolioTrendsType,
  PortfolioTrendWindow,
} from "@/types";

export const portfolioTrendsQueryKey = (
  window: PortfolioTrendWindow,
  stafferId?: string | null,
  salesId?: string | null,
) => ["portfolio", "trends", window, stafferId ?? null, salesId ?? null] as const;

export function useGetPortfolioTrends(
  window: PortfolioTrendWindow,
  stafferId?: string | null,
  salesId?: string | null,
) {
  return useQuery({
    queryKey: portfolioTrendsQueryKey(window, stafferId, salesId),
    queryFn: async () => {
      const params = new URLSearchParams({ window });
      if (stafferId != null) params.set("stafferId", stafferId);
      if (salesId != null) params.set("salesId", salesId);

      const res = await guacHttpClient.get<
        PortfolioTrendsType,
        HttpResponse<PortfolioTrendsType>
      >(`portfolio/trends?${params.toString()}`);

      return res.data;
    },
    placeholderData: (previousData) => previousData,
  });
}
